import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaImage,FaSlidersH,FaRegImages,FaFilePdf,FaRegCommentDots,FaUsersCog, FaFileContract, FaUserShield
} from 'react-icons/fa';

const settingSections = [
  {
    title: 'Banner Settings',
    items: [
       { title: 'Slider', icon: <FaImage />, path: '/banner' },
       { title: 'Sakhyam Ads', icon: <FaSlidersH />, path: '/slider' },
       { title: 'Chapter Ads', icon: <FaRegImages />, path: '/smallBanner' },
    ],
  },
  {
    title: 'PDF Settings',
    items: [
       
       { title: 'Download', icon: <FaFilePdf />, path: '/pdf' },
       { title: 'FeedbackType', icon: <FaRegCommentDots />, path: '/feedbackType' },
    ],
  },
  {
    title: 'Other Settings',
      items: [
      { title: 'MemberPolicy', icon: <FaUsersCog />, path: '/memberPolicy' },
      { title: 'TermCondition', icon: <FaFileContract />, path: '/termCondition' },
      { title: 'PrivacyPolicy', icon: <FaUserShield />, path: '/privacyPolicy' },
    ],
  },
];

const Setting = () => { 
  return (
    <div className="container">
      <h3 className="mb-2">Settings</h3>

      {settingSections.map((section, idx) => (
        <div key={idx} className="mb-4">
          <h5 className="mb-3 text-center">{section.title}</h5>
          <div className="row">
            {section.items.map((item, index) => (
              <div key={index} className="col-sm-2 mb-2">
                <NavLink to={item.path} className="text-decoration-none">
                  <div className="card text-center p-3 shadow-sm border h-100">
                    <div className="text-primary-custom fs-4 mb-2">{item.icon}</div>
                    <h6 className="mb-0 text-dark">{item.title}</h6>
                  </div>
                </NavLink>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Setting;
